/* eslint-disable react/prop-types */
import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { connect } from 'react-redux';
import { makeStyles, Grid, FormControl, Button, Select, MenuItem, Typography, FormGroup } from '@material-ui/core';

import Tab from 'src/components/tab';
import Checkbox from 'src/components/checkbox';
import DateRangePicker from 'src/components/dateRangePicker';

import XlsIcon from 'src/assets/icons/xls.svg';

import { setChecked, setTabExpend } from './slice';

const useStyles = makeStyles(theme => ({
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

const FilterBy = props => {
  const { checkList, isTabExpended } = props;
  const classes = useStyles();

  const prismicContent = useStaticQuery(graphql`
    query {
      allPrismicOverview {
        edges {
          node {
            data {
              title1 {
                html
                text
                raw
              }
              tooltip1a {
                html
                text
                raw
              }
              tooltip1b {
                html
                text
                raw
              }
              tooltip1c {
                html
                text
                raw
              }
              tooltip1d {
                html
                text
                raw
              }
              tooltip1e {
                html
                text
                raw
              }
            }
          }
        }
      }
    }
  `);

  const prismicData = prismicContent.allPrismicOverview.edges[0].node.data;

  const handelExpand = () => {
    props.setTabExpend(!isTabExpended);
  };

  const handelCheck = ({ target }) => {
    const { name, checked } = target;
    props.setChecked({ name, checked });
  };

  return (
    <Tab title="Overview Data Download Filters" onClick={handelExpand} expanded={isTabExpended}>
      <Grid container spacing={5}>
        <Grid item xs={3}>
          <div>
            <FormControl variant="outlined" color="secondary" size="small" margin="dense" fullWidth>
              <Typography variant="overline" gutterBottom>
                Date
              </Typography>
              <DateRangePicker />
            </FormControl>
          </div>
          <div>
            <FormControl variant="outlined" color="secondary" size="small" margin="dense" fullWidth>
              <Typography variant="overline" gutterBottom>
                Group
              </Typography>
              {/* <InputLabel>Select Group</InputLabel> */}
              <Select defaultValue="0">
                <MenuItem value={0}>All Groups</MenuItem>
                <MenuItem value={1}>Group 1</MenuItem>
                <MenuItem value={2}>Group 2</MenuItem>
                <MenuItem value={3}>Group 3</MenuItem>
              </Select>
            </FormControl>
          </div>
        </Grid>
        <Grid item xs={9}>
          <div>
            <Typography variant="overline">Call status</Typography>
            <Grid container>
              <Grid item xs={1}>
                <Checkbox label="All" id="all" checked={checkList.all} onChange={handelCheck} />
              </Grid>
              <Grid item xs={3}>
                <Checkbox
                  label="86’d"
                  id="86d"
                  checked={checkList.all || checkList['86d']}
                  onChange={handelCheck}
                  tooltipText={prismicData.tooltip1a.text}
                />
              </Grid>
              <Grid item xs>
                <Checkbox
                  label="Connected"
                  id="connected"
                  checked={checkList.all || checkList.connected}
                  onChange={handelCheck}
                  tooltipText={prismicData.tooltip1b.text}
                />
              </Grid>
              <Grid item xs>
                <Checkbox
                  label="Not connected"
                  id="notConnected"
                  checked={checkList.all || checkList.notConnected}
                  onChange={handelCheck}
                  tooltipText={prismicData.tooltip1c.text}
                />
              </Grid>
              <Grid item xs>
                <Checkbox
                  label="No answer"
                  id="noAnswer"
                  checked={checkList.all || checkList.noAnswer}
                  onChange={handelCheck}
                  tooltipText={prismicData.tooltip1d.text}
                />
              </Grid>
            </Grid>
            <FormGroup row>
              <Grid item xs={1} />
              <Grid item xs={3}>
                <Checkbox
                  label="Tagged Yes"
                  id="taggedYes"
                  checked={checkList.all || checkList.taggedYes}
                  onChange={handelCheck}
                  tooltipText={prismicData.tooltip1e.text}
                />
              </Grid>
              <Grid item>
                <Checkbox
                  label="Tagged No"
                  id="taggedNo"
                  checked={checkList.all || checkList.taggedNo}
                  onChange={handelCheck}
                />
              </Grid>
            </FormGroup>
          </div>
        </Grid>
      </Grid>
      <div className={classes.buttonWrapper}>
        <Button startIcon={<XlsIcon />} color="primary">
          Download Data
        </Button>
      </div>
    </Tab>
  );
};

const mapStateToProps = ({ me }) => {
  const { overview } = me;
  const { filterBy } = overview;
  return { ...filterBy };
};

const mapDispatchToProps = { setChecked, setTabExpend };

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(FilterBy));
